import i18n from '@/i18n';
import { ProjectMember } from '@/types';
import { map } from 'ramda';

export const setNameForDeletedUsers = map((user: Pick<ProjectMember, 'id' | 'fullname'>) => ({
  ...user,
  fullname: user.fullname || i18n.global.t('deletedUser').toString(),
}));
